<div class="navbar-nav dropdown justify-content-end">
  <div
    class="nav-link dropdown-toggle"
    id="navbarDropdown"
    title="Profile"
    role="button"
    data-toggle="dropdown"
    aria-haspopup="true"
    aria-expanded="false"
  >
    <img *ngIf="userService.img" class="rounded-circle header-avatar" [src]="userService.img" />
    <span class="circle-sm" *ngIf="!userService.img">{{ userService?.userData?.name?.toUpperCase()?.substring(0, 2) ?? '' }}</span>
  </div>
  <div class="dropdown-menu dropdown-menu-right settings-dropdown" aria-labelledby="navbarDropdown">
    <div class="dropdown-item default" (click)="gotoLink('/dashboard'); removeClassToBodyForResponsiveMenu()">
      <div class="row">
        <div class="col-3 avatar-section">
          <img *ngIf="userService.img" class="rounded-circle header-avatar-bigger" id="settings-avatar" [src]="userService.img" />
          <span class="circle-md" *ngIf="!userService.img">{{ userService?.userData?.name?.toUpperCase()?.substring(0, 2) ?? '' }}</span>
        </div>
        <div class="col-8">
          <table>
            <tr>
              <td class="user-title-font username-email-section">{{ userService?.userData?.name }}</td>
            </tr>
            <tr>
              <td class="user-details-font username-email-section">{{ userService?.userData?.email }}</td>
            </tr>
          </table>
        </div>
      </div>
    </div>
    <div class="divider"></div>
    <div
      class="dropdown-item d-flex px-2 py-1"
      id="userMenuProfileLink"
      (click)="gotoLinkParam('/user/', userService?.userData?.uriLabel); removeClassToBodyForResponsiveMenu()"
    >
      <div class="col-2 ml-1 icon-center">
        <svg xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 23 23" height="20" viewBox="0 0 23 23" width="20">
          <g><path d="M0,0h24v24H0V0z" fill="none" /></g>
          <g>
            <g fill="var(--grey-icon-color)">
              <circle cx="10" cy="8" r="4" />
              <path
                d="M10.67,13.02C10.45,13.01,10.23,13,10,13c-2.42,0-4.68,0.67-6.61,1.82C2.51,15.34,2,16.32,2,17.35V20h9.26 C10.47,18.87,10,17.49,10,16C10,14.93,10.25,13.93,10.67,13.02z"
              />
              <path
                d="M20.75,16c0-0.22-0.03-0.42-0.06-0.63l1.14-1.01l-1-1.73l-1.45,0.49c-0.32-0.27-0.68-0.48-1.08-0.63L18,11h-2l-0.3,1.49 c-0.4,0.15-0.76,0.36-1.08,0.63l-1.45-0.49l-1,1.73l1.14,1.01c-0.03,0.21-0.06,0.41-0.06,0.63s0.03,0.42,0.06,0.63l-1.14,1.01 l1,1.73l1.45-0.49c0.32,0.27,0.68,0.48,1.08,0.63L16,21h2l0.3-1.49c0.4-0.15,0.76-0.36,1.08-0.63l1.45,0.49l1-1.73l-1.14-1.01 C20.72,16.42,20.75,16.22,20.75,16z M17,18c-1.1,0-2-0.9-2-2s0.9-2,2-2s2,0.9,2,2S18.1,18,17,18z"
              />
            </g>
          </g>
        </svg>
      </div>
      <div class="col-10 default-font">Profile</div>
    </div>

    <div class="dropdown-item d-flex px-2 py-1" (click)="gotoLink('/dashboard'); removeClassToBodyForResponsiveMenu()" id="userMenuDashboardLink">
      <div class="col-2 ml-1 icon-center">
        <svg xmlns="http://www.w3.org/2000/svg" height="21px" viewBox="0 -960 960 960" width="21px" fill="var(--grey-icon-color)">
          <path
            d="M520-600v-240h320v240H520ZM120-440v-400h320v400H120Zm400 320v-400h320v400H520Zm-400 0v-240h320v240H120Zm80-400h160v-240H200v240Zm400 320h160v-240H600v240Zm0-480h160v-80H600v80ZM200-200h160v-80H200v80Zm160-320Zm240-160Zm0 240ZM360-280Z"
          />
        </svg>
      </div>
      <div class="col-10 default-font">Dashboard</div>
    </div>

    <div class="dropdown-item d-flex px-2 py-1" (click)="gotoLink('resources'); removeClassToBodyForResponsiveMenu()" id="userMenuResourcesLink">
      <div class="col-2 ml-1 icon-center">
        <i class="fa-solid fa-book header-icon"></i>
      </div>
      <div class="col-10 default-font">Resources</div>
    </div>

    <div
      class="dropdown-item d-flex px-2 py-1"
      (click)="gotoLink('terminologies'); removeClassToBodyForResponsiveMenu()"
      id="userMenuTerminologiesLink"
    >
      <div class="col-2 ml-1 icon-center">
        <i class="fa-solid fa-sitemap header-icon"></i>
      </div>
      <div class="col-10 default-font">Terminologies</div>
    </div>

    <div class="dropdown-item d-flex px-2 py-1" (click)="openFeedbackModal(); removeClassToBodyForResponsiveMenu()" id="userMenuFeedbackLink">
      <div class="col-2 ml-1 icon-center">
        <svg xmlns="http://www.w3.org/2000/svg" height="20" viewBox="0 0 23 23" width="20">
          <path d="M0 0h24v24H0zm15.35 6.41l-1.77-1.77c-.2-.2-.51-.2-.71 0L6 11.53V14h2.47l6.88-6.88c.2-.19.2-.51 0-.71z" fill="none" />
          <path
            fill="var(--grey-icon-color)"
            d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z"
          />
        </svg>
      </div>
      <div class="col-10 default-font">Provide Feedback</div>
    </div>
    <div class="dropdown-item d-flex px-2 py-1" (click)="gotoLink('settings'); removeClassToBodyForResponsiveMenu()" id="userMenuSettingsLink">
      <div class="col-2 ml-1 icon-center">
        <svg xmlns="http://www.w3.org/2000/svg" height="23px" viewBox="0 -960 960 960" width="23px" fill="var(--grey-icon-color)">
          <path
            d="M263.79-408Q234-408 213-429.21t-21-51Q192-510 213.21-531t51-21Q294-552 315-530.79t21 51Q336-450 314.79-429t-51 21Zm216 0Q450-408 429-429.21t-21-51Q408-510 429.21-531t51-21Q510-552 531-530.79t21 51Q552-450 530.79-429t-51 21Zm216 0Q666-408 645-429.21t-21-51Q624-510 645.21-531t51-21Q726-552 747-530.79t21 51Q768-450 746.79-429t-51 21Z"
          />
        </svg>
      </div>
      <div class="col-10 default-font">Settings</div>
    </div>
    <div class="divider"></div>
    <div class="dropdown-item sign-out default default-font" (click)="logout(); removeClassToBodyForResponsiveMenu()" id="userMenuSignOutLink">
      Sign Out
    </div>
  </div>
</div>

<app-feedback-modal [openModal]="isModalOpen" (modalClosed)="handleModalClosed()" isFeedbackFeature="false"> </app-feedback-modal>
